export default __webpack_public_path__ + "static/media/1.f1010aed.jpg";